// Every 5% up to 95; reaching the end is reported by `video_complete`.
const PROGRESS_MARKS = Array.from({ length: 19 }, (_, i) => (i + 1) * 5)

interface VideoMeta {
  title: string
  url: string
  provider: string
}

interface MediaLike {
  currentTime: number
  duration: number
}

export function useVideoTracking(meta: MaybeRefOrGetter<VideoMeta>) {
  let started = false
  let completed = false
  const reached = new Set<number>()

  const params = (media: MediaLike, percent: number) => {
    const { title, url, provider } = toValue(meta)
    return {
      video_title: title,
      video_provider: provider,
      video_url: url,
      video_duration: Math.round(media.duration || 0),
      video_current_time: Math.round(media.currentTime || 0),
      video_percent: percent,
    }
  }

  const media = (event: Event) => event.currentTarget as unknown as MediaLike

  const onPlaying = (event: Event) => {
    if (started) return
    started = true
    trackEvent('video_start', params(media(event), 0))
  }

  const onTimeUpdate = (event: Event) => {
    const el = media(event)
    if (!el.duration) return

    const percent = (el.currentTime / el.duration) * 100
    for (const mark of PROGRESS_MARKS) {
      if (percent >= mark && !reached.has(mark)) {
        reached.add(mark)
        trackEvent('video_progress', params(el, mark))
      }
    }
  }

  const onEnded = (event: Event) => {
    if (completed) return
    completed = true
    trackEvent('video_complete', params(media(event), 100))
  }

  return { onPlaying, onTimeUpdate, onEnded }
}
